import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "skeleton h-10 md:h-12 w-full md:w-5/6" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "skeleton mt-12 md:mt-20 h-4 w-full md:w-3/6" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "skeleton h-4" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "skeleton h-4" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "skeleton h-4" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "skeleton h-64 md:h-96" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "skeleton h-4" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "skeleton mt-8 h-4" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "skeleton mt-8 h-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_Grid = _resolveComponent("Grid")!
  const _component_Container = _resolveComponent("Container")!
  const _component_Heading = _resolveComponent("Heading")!
  const _component_Paragraph = _resolveComponent("Paragraph")!
  const _component_Picture = _resolveComponent("Picture")!
  const _component_TitleAndList = _resolveComponent("TitleAndList")!
  const _component_DynamicContent = _resolveComponent("DynamicContent")!
  const _component_ThemeChanger = _resolveComponent("ThemeChanger")!
  const _component_Notice = _resolveComponent("Notice")!
  const _component_MetaInfo = _resolveComponent("MetaInfo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ThemeChanger, null, {
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_Container, {
              key: 0,
              fluid: "",
              class: "pt-52 pb-24"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Grid, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Column, { span: [ 2, 6 ] }, {
                      default: _withCtx(() => [
                        _hoisted_1,
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      span: [ 2, 2 ],
                      class: "mt-24"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      span: [ 2, 2 ],
                      class: "mt-12 md:mt-24"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      span: [ 2, 2 ],
                      class: "mt-12 md:mt-24"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      span: [ 2, 6 ],
                      class: "mt-32"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      span: [ 2, 4 ],
                      push: [ 0, 1 ],
                      class: "mt-32"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7,
                        _hoisted_8,
                        _hoisted_9
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_Container, {
              key: 1,
              fluid: "",
              class: "pt-48 pb-24"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Grid, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Column, { span: [ 2, 4 ] }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Heading, {
                          tag: "h1",
                          innerHTML: _ctx.package.title
                        }, null, 8, ["innerHTML"]),
                        (_ctx.package.description)
                          ? (_openBlock(), _createBlock(_component_Paragraph, {
                              key: 0,
                              innerHTML: _ctx.package.description
                            }, null, 8, ["innerHTML"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_Grid, { class: "mt-20" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Column, { span: 2 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Paragraph, {
                          class: "font-bold pb-5 border-b",
                          innerHTML: _ctx.package.category.title
                        }, null, 8, ["innerHTML"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { span: 2 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Paragraph, { class: "font-bold sm:pt-5 pb-5 border-b" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.isCNLocale ? `${_ctx.package.downloads}次下载` : `${_ctx.package.downloads} Downloads`), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { span: 2 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Paragraph, { class: "font-bold sm:pt-5 pb-5 border-b" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.isCNLocale ? `${_ctx.package.stars}个星标` : `${_ctx.package.stars} Stars`), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.package.image)
                  ? (_openBlock(), _createBlock(_component_Grid, {
                      key: 0,
                      class: "pt-24"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Picture, {
                          auto: "",
                          cover: "",
                          image: _ctx.package.image
                        }, null, 8, ["image"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_Grid, { class: "pt-24" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      span: [ 2, 4 ],
                      push: [ 0, 1 ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Paragraph, {
                          innerHTML: _ctx.package.introduction
                        }, null, 8, ["innerHTML"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_Grid, { class: "mt-20" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      span: [ 2, 4 ],
                      push: [ 0, 1 ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Heading, { tag: "h2" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.isCNLocale ? '特征' : 'Features'), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_TitleAndList, {
                  list: _ctx.package.features,
                  class: "mt-7 md:mt-12"
                }, null, 8, ["list"]),
                (Object.keys(_ctx.package?.license_content).length > 0)
                  ? (_openBlock(), _createBlock(_component_Grid, {
                      key: 1,
                      class: "mt-24"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Column, {
                          span: [ 2, 4 ],
                          push: [ 0, 1 ]
                        }, {
                          default: _withCtx(() => [
                            (_ctx.package.license_heading)
                              ? (_openBlock(), _createBlock(_component_Heading, {
                                  key: 0,
                                  tag: "h3",
                                  innerHTML: _ctx.package.license_heading
                                }, null, 8, ["innerHTML"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_DynamicContent, {
                              class: "mt-5",
                              content: _ctx.package.license_content
                            }, null, 8, ["content"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
      ]),
      _: 1
    }),
    _createVNode(_component_ThemeChanger, {
      to: _ctx.Theme.Dark
    }, {
      default: _withCtx(() => [
        (_ctx.package.category)
          ? (_openBlock(), _createBlock(_component_Container, {
              key: 0,
              fluid: "",
              class: "pt-24"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Grid, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      span: [ 2, 4 ],
                      push: [ 0, 1 ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Heading, {
                          tag: "h3",
                          innerHTML: _ctx.package?.category?.about_heading
                        }, null, 8, ["innerHTML"]),
                        _createVNode(_component_DynamicContent, {
                          class: "mt-5",
                          content: _ctx.package?.category?.about_content
                        }, null, 8, ["content"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_Grid, { class: "mt-24" }, {
                  default: _withCtx(() => [
                    (_ctx.package.category.custom_package_label && _ctx.package.category.custom_package_content)
                      ? (_openBlock(), _createBlock(_component_Column, {
                          key: 0,
                          span: [ 2, 4 ],
                          push: [ 0, 1 ]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Notice, {
                              title: _ctx.package.category.custom_package_label,
                              description: _ctx.package.category.custom_package_content
                            }, null, 8, ["title", "description"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.package.category.build_app_label && _ctx.package.category.build_app_content)
                      ? (_openBlock(), _createBlock(_component_Column, {
                          key: 1,
                          span: [ 2, 4 ],
                          push: [ 0, 1 ],
                          class: "mt-16"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Notice, {
                              title: _ctx.package.category.build_app_label,
                              description: _ctx.package.category.build_app_content
                            }, null, 8, ["title", "description"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["to"]),
    (_ctx.package.seo)
      ? (_openBlock(), _createBlock(_component_MetaInfo, {
          key: 0,
          seo: _ctx.package.seo,
          "structured-data": _ctx.package.seo_structured_data,
          published: _ctx.package.date,
          modified: _ctx.package.last_modified
        }, null, 8, ["seo", "structured-data", "published", "modified"]))
      : _createCommentVNode("", true)
  ], 64))
}